import React, { useContext, useState } from 'react';

const GlobalContext = React.createContext({})
export const useGlobalContext = () => useContext(GlobalContext)

export const GlobalProvider = ({ children }) => {
  const [isNested, setNested] = useState(false)
  const [child, setChild] = useState('')
  const [isLightTheme, setLightTheme] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const store = {
    isNested,
    setNested,
    isLightTheme,
    setLightTheme,
    menuOpen,
    setMenuOpen,
    child,
    setChild
  }

  return (
    <GlobalContext.Provider value={store}>
      {children}
    </GlobalContext.Provider>
  )

}